/**
 * Product IDs that are referenced in multiple places in the codebase.
 */
export const KNOWN_PRODUCT_IDS = {
  blast: 113,
  blastPerp: 114,
  degenPerp: 140,
  wS: 145,
  wethArb: 3,
  wethBase: 117,
  wethBlast: 91,
  wethBlastSepolia: 3,
  wethMantle: 93,
  wethMantleSepolia: 3,
  wavax: 51,
  wmnt: 109,
  wsei: 115,
} as const;
